// @ts-nocheck
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/lib/supabase';

export function useSportsByGender(gender?: string) {
  const { data: sports = [], isLoading } = useQuery({
    queryKey: ['sports', gender],
    queryFn: async () => {
      let query = supabase
        .from('sports')
        .select('*')
        .eq('is_active', true)
        .order('name');

      // Filter by gender if selected
      if (gender && gender !== '') {
        query = query.eq('gender', gender);
      }

      const { data, error } = await query;
      
      if (error) throw error;
      return data || [];
    }
  });

  return { sports, isLoading };
}
